import { render, staticRenderFns } from "./AttachmentTypeTemplateCreate.vue?vue&type=template&id=3f89a8d4&"
import script from "./AttachmentTypeTemplateCreate.vue?vue&type=script&lang=js&"
export * from "./AttachmentTypeTemplateCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports